export default __webpack_public_path__ + "static/media/down.24af199e.svg";